//database record in share cloud database 

import { NodeModel } from "./hsbcad-model";

export interface IProjectDB {
    activeUrn: string;
    callingUserTeamAdmin: boolean;
    currentUserLastAccess: string;
    currentUserNumberOfTimesOpen: number;
    isHsbProject: boolean;
    isPublic: boolean;
    name:string;
    projectID: string;
    sets: Array<ISetDB>;
    siteProjectID: string;
    teamID: string;
    teamName: string;
    users: Array<{email: string}>;
    index: number;
    nodeDataStorage: NodeDataStorage;
    nodeModel: NodeModel;
}
export class ProjectDB implements IProjectDB {
    constructor(name:string, projectID: string){
        this.name = name;
        this.projectID = projectID;
        this.sets = [];
        this.users = [];
    }
    activeUrn!: string;
    callingUserTeamAdmin!: boolean;
    currentUserLastAccess!: string;
    currentUserNumberOfTimesOpen!: number;
    isHsbProject!: boolean;
    isPublic!: boolean;
    name: string;
    projectID: string;
    sets: ISetDB[];
    siteProjectID!: string;
    teamID!: string;
    teamName!: string;
    users: { email: string; }[];
    index!: number;
    nodeDataStorage!: NodeDataStorage;
    nodeModel!: NodeModel;
}

export interface ISetDB{
    name: String,
    urns: Array<IUrnDB>;
}
export interface IUrnDB{
    urn: string;
    name: string;
    meta: string;
    visible: boolean;
}

export enum NodeDataStorage {
    EFS = 'efs',
    MongoDB = 'mongoDB',
    Unknown = 'unknown'
}

